import React from "react";
import frame from "../../../images/Frame.png";
import { useNavigate, useLocation } from "react-router-dom";

const AutomateContent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section className="flex flex-col items-center justify-center text-center md:mt-14 mt-14 lg:mt-1 ">
      <div className="self-center max-w-full sm:max-w-[100%] md:max-w-[90%] xl:max-w-[90%] md:space-y-2 sm:space-x-0">
        <h3 className="font-bold text-[22px] sm:text-[28px] lg:text-[35px] italic leading-snug">
          Automate Your Manufacturing Workflow<br className="hidden sm:inline" /> And Enhance Your Margin With Ease
        </h3>

        <p style={{ color: '#000000' }} className="md:text-[18px] text-[17px] sm:text-[15px] leading-relaxed">
          From <strong style={{ color: '#1780fb' }}>Inventory</strong> to <strong style={{ color: '#1780fb' }}>Production</strong><br /> managed with ease.
        </p>

        <div className="mx-auto inline-block px-[5px] py-[5px] border border-black rounded-[10px]">
          <button
            type="button"
            className="px-[16px] sm:px-[22px] py-[8px] rounded-[10px] text-sm text-white font-semibold bg-[#1677ff] hover:bg-[#4096ff] transition-colors duration-200"
            onClick={() => navigate("/requestdemo")}
          >
            Request a Demo
          </button>
        </div>
      </div>

      <video
        src="./EasePromo.mp4"
        autoPlay
        muted
        loop
        controls
        className="w-full h-[220px] md:h-[500px] lg:w-[90%] lg:h-[65vh] rounded-2xl mt-4 object-cover"
      />

      {/* <img
        src={frame}
        alt="Hero"
        className="w-full max-w-full sm:max-w-4xl lg:max-w-2xl md:h-auto h-[220px] mt-2 lg:mt-6 mx-auto block "
      /> */}
    </section>
  );
};

export default AutomateContent;
